import React from "react";
import { Skeleton, Box, Grid } from "@mui/material";

export default function Skeletons({
  numOfSkeletons = 1,
  grid = true,
  width = "100%",
  height = 120,
  spacing = 1,
  xs = 12,
  sm = 6,
  md = 2,
  lg = 2,
}) {
  return grid ? (
    <Grid container spacing={spacing}>
      {Array.from({ length: numOfSkeletons }).map((_, index) => (
        <Grid item xs={xs} sm={sm} md={md} lg={lg} key={index}>
          <Skeleton variant="rectangular" width={width} height={height} />
        </Grid>
      ))}
    </Grid>
  ) : (
    <Box display="flex" flexDirection="column" gap={2}>
      {Array.from({ length: numOfSkeletons }).map((_, index) => (
        <Skeleton
          key={index}
          variant="rectangular"
          width={width}
          height={height}
        />
      ))}
    </Box>
  );
}
